export const isOdd = (nbr: number) => Boolean(nbr % 2);
